<template>
    <transition name="fade-block">
        <div class="song-widget suggestion col-xs-6 p-h-5" :class="{'song': isSong, 'playlist': isPlaylist}">
            <div class="inner-container" v-if="isSong" :class="{'liked' : isLiked, 'disliked' : isDisliked, 'playing': activeSongId == widgetSong.id}">
                <div class="new-badge" v-show="isNew">NEW</div>
                <div @click="play" class="thumbnail">
                    <div :data-img="getImage" class="lazzyLoad"></div>
                </div>
                <div class="artist" @click="openRoute">{{ widgetSong.artist }}</div>
                <div class="name" @click="openRoute">{{ widgetSong.name }}</div>
                <div class="uploader" v-if="widgetSong.uploader" @click="openUploader">{{ widgetSong.uploader.name }}</div>

                <div class="suggestedby">
                    <b>SUGGESTED BY</b><br>
                    <span>{{ data.proposer.name }}</span>
                </div>

                <div class="info" v-html="views"></div>
                <div class="button button-center more" @click="showOptions = 1">
                    <i class="iconify" data-icon="zmdi:more"></i>
                </div>

                <transition name="page-overlay" class="move-to-root">
                    <div class="page-overlay dark song-options" :id="oid" v-show="showOptions == 2" v-if="showOptions">
                        <div class="container">
                            <div class="row">
                                <div class="col-xs-12">
                                    <ul v-if="!isOwner">
                                        <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                        <li class="button button-white" @click="toggleBlock()">{{ isBlocked ? 'Unblock' : 'Block' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                        <li class="button button-white" @click="toggleFollow()">{{ isFollowed ? 'Unfollow' : 'Follow' }} {{ isArtist ? 'artist' : 'label' }}</li>
                                        <li class="button button-white" @click="toggleLike()">{{ isLiked ? 'Dislike' : 'Like' }}</li>
                                        <li class="button button-white" @click="shareMobile()">Share</li>
                                    </ul>

                                    <ul v-else>
                                        <!-- <li class="button button-white disabled">Edit</li> -->
                                        <li class="button button-white" @click="showPlaylistManager()">Add to Playlist</li>
                                        <li class="button button-white" @click="toggleRelease()" v-show="!hasNoVideo">{{ !isReleased ? 'Release' : 'Unrelease' }}</li>
                                        <li class="button button-white" @click="togglePublish()" v-show="!hasNoVideo">{{ !isPublished ? 'Publish' : 'Unpublish' }}</li>
                                        <li class="button button-white" @click="shareMobile()">Share</li>
                                    </ul>
                                </div>
                            </div>

                            <div class="col-xs-12 text-center m-t-16">
                                <div class="btn btn-round button" @click="showOptions = 3">back</div>
                            </div>
                        </div>
                    </div>
                </transition>
            </div>

            <div class="inner-container" v-if="isPlaylist">
                <div class="thumbnail" @click="openRoute">
                    <div :data-img="getImage" class="lazzyLoad"></div>
                </div>
                <div class="artist" @click="openRoute">PLAYLIST</div>
                <div class="name" @click="openRoute">{{ widgetSong.name }}</div>

                <div class="uploader">&nbsp;</div>
                <div class="suggestedby">
                    <b>SUGGESTED BY</b><br>
                    <span>{{ data.proposer.name }}</span>
                </div>

                <div class="info">&nbsp;</div>
                <router-link :to="playlistPage" tag="span" class="more" v-if="2==1">
                    <i class="iconify" data-icon="zmdi:more" data-height="26" data-width="24" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>
                </router-link>            
            </div>            
        </div>

        <div v-if="!data" class="song-widget col-xs-6 p-h-5">
            <div class="inner-container-mokup"></div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['song'],

    data() {
        return {
            widgetSong: this.song.suggestable_data,
            data: this.song,
            oid: "options_"+ this.song.id +"_"+ Math.random().toString(36).substr(2, 9),
            showOptions: 0,
            activeSongId: 0            
        }
    },

    activated() {
        LazzyLoad();
        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    mounted() {
        LazzyLoad();

        this.$root.$emit('requestCurrentSong');
        this.$root.$on('currentSongPlaying', (songId, state) => {
            this.activeSongId = state != 'stopped' ? songId : 0;
        })
    },

    methods: {
        play(){
            if (this.hasNoVideo) return;

            if (this.isSong){
                this.$root.$emit('mp-load-song', this.widgetSong, false);
            }
        },

        openRoute() {
            if (this.isSong){
                App.queryParams = this.widgetSong;
                this.$router.push({path: '/song/' + this.data.suggestable_id});
            }

            if (this.isPlaylist){
                this.$router.push({path: '/playlist/' + this.data.suggestable_id});
            }
        },

        openUploader() {
            App.queryParams = this.widgetSong.uploader;
            this.$router.push({path: '/profile/' + this.widgetSong.uploader.id});
        },

        showPlaylistManager(){
            this.showOptions = 3;
            setTimeout(() => {
                this.$root.$emit('showPlaylistManager', this.widgetSong);    
            }, 350);
        },

        formatNumber(value){
            if (value > 1000000) return (value / 1000000).toFixed(1) +'M';
            if (value > 1000) return (value / 1000).toFixed(1) +'K';
            return Math.max(0, value);
        },

        toggleLike(type) {
            var review = this.widgetSong.review;
            this.widgetSong.review = this.isLiked ? 'dislike' : 'like';

            this.$http.post(this.reviewEndpoint, { review: this.widgetSong.review }).then(() => {}, (error) => { this.widgetSong.review = review; });
        },

        toggleFollow() {
            var pick = this.widgetSong.artist_pick === 'followed' ? 'unfollow' : 'follow';
            this.updatePick(pick);
        },

        toggleBlock() {
            var pick = this.widgetSong.artist_pick === 'blocked' ? 'unblock' : 'block';
            this.updatePick(pick);
        },

        updatePick(pick) {
            this.$http.post(this.updatePickEndpoint, { pick: pick }).then((success) => {
                this.widgetSong.artist_pick = success.data.data.status;
                // this.$root.$emit('pickUpdated', this.widgetSong.artist_pick, this.widgetSong.uploader.id);
            });
        },

        togglePublish() {
            var verb = this.widgetSong.released ? 'delete' : 'post';
            this.$http[verb](this.publishEndpoint).then((success) => {
                this.widgetSong.released = !this.widgetSong.released;
            });            
        },

        toggleRelease() {
            var verb = this.widgetSong.public ? 'delete' : 'post';
            this.$http[verb](this.releaseEndpoint).then((success) => {
                this.widgetSong.public = !this.widgetSong.public;
            });            
        },

        shareMobile(){
            if (navigator.share) {
                navigator.share({
                    title: `${this.widgetSong.name} - ${this.widgetSong.artist}`,
                    text: `Check out this great song from ${this.widgetSong.uploader.name}`,
                    url: this.widgetSong.url
                }).then(() => console.log('Successful share'))
                .catch(error => console.log('Error sharing:', error));
            }else{
                alert('Navigator share disabled')
            }
        }        
    },

    computed: {
        reviewEndpoint() {
            return App.restApi + '/api/song/' + this.widgetSong.id + '/review';
        },

        updatePickEndpoint() {
            return App.restApi + '/api/user/' + this.widgetSong.uploader.id + '/picks';
        },

        publishEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.widgetSong.id + '/released';
        },

        releaseEndpoint(){
            return App.restApi + '/api/v2/songs/' + this.widgetSong.id + '/public';
        },

        hasNoVideo(){
            return this.song.url == 'https://www.youtube.com/watch?v=soundfeed';
        },

        isLiked(){ return this.widgetSong.review == 'like'; },
        isDisliked(){ return this.widgetSong.review == 'dislike'; },
        isFollowed(){ return this.widgetSong.artist_pick === 'followed'; },
        isBlocked(){ return this.widgetSong.artist_pick === 'blocked'; },
        isPublished(){ return this.widgetSong.released; },
        isReleased(){ return this.widgetSong.public; },

        isArtist() { return this.widgetSong.uploader.type == 'artist'; },
        isLabel() { return this.widgetSong.uploader.type == 'label'; },         
        isOwner() { return App.user.id == this.widgetSong.uploader_id || App.user.id == 21; },

        songPage() {
            return '/song/' + this.widgetSong.id;
        },

        playlistPage() {
            return '/suggestions/playlist/' + this.widgetSong.id;
        },

        isNew(){
            return this.song.viewed ? false : true;
        },

        views(){
            var views = this.widgetSong.views && this.widgetSong.views.youtube ? this.formatNumber(this.widgetSong.views.youtube.count) : "NEW";
            return `<span class="text-dark">${views}</span>`;
        },
 
        isPlaylist(){
            return this.data.suggestable_type == "App\\Playlist";
        },

        isSong(){
            return this.data.suggestable_type == "App\\Song";
        },

        getImage() {
            return `${App.restApi}/api/image/` + (this.data.suggestable_type == "App\\Playlist" ? this.widgetSong.image_name : this.widgetSong.picture_path) + `?width=256`;
        }        
    },

    watch:{
        showOptions(){
            if (this.showOptions == 3){
                setTimeout(() => {
                    this.showOptions = 0;
                }, 500);
            }

            if (this.showOptions == 1){
                this.$nextTick(() => {
                    $('#musicplayer').after( $("#"+ this.oid) );
                    this.showOptions = 2; 
                });
            }
        }
    },

    beforeDestroy(){
        $("#"+ this.oid).remove();
        this.$root.$off(['currentSongPlaying']);
    }    
}
</script>
